import { render, staticRenderFns } from "./ChargeDetailList.vue?vue&type=template&id=4bf3cbfd&scoped=true&"
import script from "./ChargeDetailList.vue?vue&type=script&lang=js&"
export * from "./ChargeDetailList.vue?vue&type=script&lang=js&"
import style0 from "./ChargeDetailList.vue?vue&type=style&index=0&id=4bf3cbfd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf3cbfd",
  null
  
)

export default component.exports